import { styles } from './JudgeDetail.styles';

export const JudgeDetailLoading = () => (
	<>
		<header className={styles.topbar}>
			<div className="h-md w-[120px] animate-pulse rounded bg-grey-25" />
		</header>
		<main className={styles.content}>
			<div className="h-[28px] w-[200px] animate-pulse rounded bg-grey-25" />
			{['a', 'b', 'c'].map((k) => (
				<div key={`field-${k}`} className="h-[64px] animate-pulse rounded bg-grey-25" />
			))}
		</main>
	</>
);
